module.exports = __webpack_public_path__ + "img/info-security-24.83b914dc.svg";